"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricsProvider = exports.useMetrics = exports.MetricsContext = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var sli_metrics_client_1 = require("@cvent/sli-metrics-client");
/**
 * Provide an empty implementation of the common uses of useMetrics to
 * prevent crashes / exceptions during tests and when no provider is used.
 */
exports.MetricsContext = React.createContext({});
var useMetrics = function () { return (0, react_1.useContext)(exports.MetricsContext); };
exports.useMetrics = useMetrics;
/**
 * Helper function to maintain backwards type/eventName compatibility when type is set as string
 */
var getMetricEventTypeId = function (type) { return (typeof type === 'string' ? type : type.id); };
/**
 * Helper function to maintain destinations backwards compatibility when type is set as string.
 */
var getMetricEventData = function (type, data) {
    var metricEventTypeDestinations = typeof type === 'string' ? undefined : type.destinations;
    var destinations = (data === null || data === void 0 ? void 0 : data.destinations) || metricEventTypeDestinations;
    return __assign(__assign({}, data), { destinations: destinations });
};
/**
 * This provider is required if the useMetrics hook is going to be used. It provides
 * a metrics instance, as well as tracking functions (for readability).
 */
var MetricsProvider = function (_a) {
    var reporters = _a.reporters, baseData = _a.baseData, children = _a.children;
    var metrics = (0, react_1.useRef)(new sli_metrics_client_1.MetricsClient(reporters, baseData));
    (0, react_1.useEffect)(function () {
        metrics.current.reporters = reporters;
    }, [reporters]);
    (0, react_1.useEffect)(function () {
        metrics.current.baseData = baseData;
    }, [baseData]);
    var trackingFunctions = (0, react_1.useRef)({
        trackEvent: function (type, data, options, callback) { return metrics.current.trackEvent(getMetricEventTypeId(type), getMetricEventData(type, data), options, callback); },
        measureEvent: function (type, initialData, options) { return metrics.current.measureEvent(getMetricEventTypeId(type), initialData, options); },
        measureFunction: function (func, type, data, options) {
            return metrics.current.measureFunction(func, type, data, options);
        },
        getBaseProps: function () { var _a; return (_a = metrics.current) === null || _a === void 0 ? void 0 : _a.baseData; }
    });
    return (React.createElement(exports.MetricsContext.Provider, { value: __assign({ metrics: metrics.current }, trackingFunctions.current) }, children));
};
exports.MetricsProvider = MetricsProvider;
